import { gaEvent } from 'src/utils'

/**
 * [TARGET]: Ao enviar um formulário de cartão de crédito, caso dê sucesso ou erro vamos emitir um evento.
 *
 * [CONTEXTO]: Na última etapa do link de pagamento, ao efetuar um pagamento, pode dar um sucesso ou erro, caso isso ocorra vamos emitir um evento.
 *
 * [REGRAS]: n/a
 *
 */
export type PaymentCallbackEventParams = {
  type: 'sucesso' | 'erro'
  errorMessage?: string
}
export const paymentCallbackEvent = ({ type, errorMessage }: PaymentCallbackEventParams) => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'callback:pagamento',
    'event-label': `${type}${errorMessage ? `:${errorMessage}` : ''}`,
  }

  gaEvent(event)
}
